import { lockForMyContainerDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getlockForMyContainerEn = () => {
  const data = lockForMyContainerDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addlockForMyContainerRequest = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/where-can-i-get-a-lock-for-my-container`,
    ) &&
    document.getElementById(`lockForMyContainerJSONLD`) === null
  ) {
    const script = lockForMyContainerJSONLDEn()
    addJSONLDToHead(script, `lockForMyContainerJSONLD`)
  } else {
    removeElement(`lockForMyContainerJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const lockForMyContainerJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getlockForMyContainerEn(),
  }
  return FaqBagsterTemplate
}
